import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ContainerService {

	private API_URL: string;
	public applicationContainers: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
	public applicationUserContainers: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	constructor(private http: HttpClient) {
		this.API_URL = environment.apiUrl;
	}

	public getAllUserEvents(thingId: number, userActive: boolean): Observable<any> {
		return this.http
			.get(`${this.API_URL}thing/${thingId}/container${
				userActive ? '?only_thing_active=1' : ''
			}`)
			.pipe(map((res: any) => res.data));
	}

	public getAllApplicationEvents(): Observable<any> {
		return this.http
			.get(`${this.API_URL}container`)
			.pipe(map((res: any) => res.data));
	}

	public clearContainerData(): void {
		this.applicationContainers.next([]);
		this.applicationUserContainers.next([]);
	}

}
